import React, { useState, useCallback } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
  Alert
} from '@mui/material';
import QuizAnalytics from './QuizAnalytics';
import UserRegistrationAnalytics from './UserRegistrationAnalytics';
import DashboardOverview from './DashboardOverview';
import Header from '../Header';

const AdminAnalytics = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleError = useCallback((errorMessage) => {
    setError(errorMessage);
    setLoading(false);
  }, []);

  const handleLoading = useCallback((isLoading) => {
    setLoading(isLoading);
    if (isLoading) {
      setError(null);
    }
  }, []);

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
          <Typography variant="h6" sx={{ ml: 2 }}>
            Loading analytics...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Admin Analytics Dashboard
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{ mb: 3 }}
          variant="fullWidth"
        >
          <Tab label="Dashboard Overview" />
          <Tab label="Quiz Analytics" />
          <Tab label="User Registration" />
        </Tabs>

        <Box sx={{ mt: 3 }}>
          {activeTab === 0 && (
            <DashboardOverview
              onError={handleError}
              onLoading={handleLoading}
            />
          )}

          {activeTab === 1 && (
            <QuizAnalytics
              onError={handleError}
              onLoading={handleLoading}
            />
          )}

          {activeTab === 2 && (
            <UserRegistrationAnalytics
              onError={handleError}
              onLoading={handleLoading}
            />
          )}
        </Box>
      </Container>
    </>
  );
};

export default AdminAnalytics;
